module.exports = __webpack_public_path__ + "static/media/shipService.aa926052.jpg";